import { useConfigStore } from '@/stores/config';
import { useConversationStore } from "@/stores/conversation";
import { useNavigationStore } from "@/stores/navigation";
import CoreService from "@/services/core.service";
import SearchInputField from "@/components/SearchInputField.vue";
import { Minimize2, Maximize2, ArrowLeft, X } from 'lucide-vue-next';
import ParentService from "@/services/parent.service";
import { Views } from "@/types/ConfigTypes";
export default {
    name: 'Article',
    components: { SearchInputField, Minimize2, Maximize2, ArrowLeft, X },
    props: {
        title: String,
        body: String
    },
    data() {
        return {};
    },
    setup() {
        return {
            coreService: CoreService,
            configStore: useConfigStore(),
            navStore: useNavigationStore(),
            conversationStore: useConversationStore()
        };
    },
    computed: {
        getCurrentConversation() {
            return this.conversationStore.getCurrentConversation;
        },
        isMobile() {
            return ParentService.isMobile();
        },
        isAssignedToAgent() {
            return this.conversationStore.getCurrentConversation.agent?.nick || this.conversationStore.getCurrentConversation.agent?.name;
        },
        isMessengerLaunchButtonShown() {
            return ParentService.getLaunchIconVisibility() === 'VISIBLE';
        },
        isFullScreenMode() {
            return this.configStore.isFullScreenMode;
        }
    },
    methods: {
        backButtonClicked() {
            CoreService.goBack();
        },
        toggleResizeButtonClicked() {
            this.configStore.toggleFrameSize();
            // ParentService.toggleFrameSize()
        },
        // toggleTheme() {
        //   const newTheme = this.configStore.currentTheme === 'light' ? 'dark' : 'light'
        //   this.configStore.setTheme(newTheme)
        // },
        test() {
            CoreService.setToFloatingConversation(9876543210);
        },
        closeMessenger() {
            ParentService.closeMessenger();
        },
        setLocale(s) {
            if (s === 'العربية')
                s = 'ar';
            this.configStore.setLocale(s);
            this.$root.$i18n.locale = s;
            CoreService.replace(Views.PAGE, { id: 'home', rerender: s });
        }
    }
};
